/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count syllables, words and characters in any text. Free syllable counter for poetry, haiku and songwriting. No signup.`)
};

const es_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta sílabas, palabras y caracteres en cualquier texto. Contador de sílabas gratuito para poesía, haikus y composición de canciones. Sin registro.`)
};

const de_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zähle Silben, Wörter und Zeichen in jedem Text. Kostenloser Silbenzähler für Gedichte, Haikus und Songtexte. Keine Anmeldung nötig.`)
};

const nl_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel lettergrepen, woorden en tekens in elke tekst. Gratis lettergreepteller voor poëzie, haiku's en songteksten. Geen registratie nodig.`)
};

const fr_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez les syllabes, les mots et les caractères de n'importe quel texte. Compteur de syllabes gratuit pour la poésie, les haïkus et l'écriture de chansons. Sans inscription.`)
};

const it_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta sillabe, parole e caratteri in qualsiasi testo. Contatore di sillabe gratuito per poesia, haiku e scrittura di canzoni. Nessuna registrazione.`)
};

const pt_br2_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte sílabas, palavras e caracteres em qualquer texto. Contador de sílabas gratuito para poesia, haiku e composição de letras. Sem cadastro.`)
};

const pt_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conte sílabas, palavras e caracteres em qualquer texto. Contador de sílabas gratuito para poesia, haiku e composição de letras. Sem registo.`)
};

const ja_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あらゆるテキストの音節数、単語数、文字数をカウントします。詩や俳句、作詞に使える無料の音節カウンター。登録不要。`)
};

const zh_syl_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计任意文本的音节数、单词数和字符数。适用于诗歌、俳句和歌词创作的免费音节计数器，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_tool_description", locale)
	if (locale === "en") return en_syl_tool_description(inputs)
	if (locale === "es") return es_syl_tool_description(inputs)
	if (locale === "de") return de_syl_tool_description(inputs)
	if (locale === "nl") return nl_syl_tool_description(inputs)
	if (locale === "fr") return fr_syl_tool_description(inputs)
	if (locale === "it") return it_syl_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_syl_tool_description(inputs)
	if (locale === "pt") return pt_syl_tool_description(inputs)
	if (locale === "ja") return ja_syl_tool_description(inputs)
	return zh_syl_tool_description(inputs)
};